import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleActivitiesSummarizedByStudentUseCaseInterface } from 'domain/usecases';

export class RemoteHandleActivitiesSummarizedByStudent
  implements HandleActivitiesSummarizedByStudentUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleActivitiesSummarizedByStudentUseCaseInterface.Result>,
  ) {}

  async execute(
    params: HandleActivitiesSummarizedByStudentUseCaseInterface.Params,
  ): Promise<HandleActivitiesSummarizedByStudentUseCaseInterface.Result> {
    const { type, ...restArgs } = params;
    const requestUrl = generateUrl(this.url + `/${type}`, restArgs as any);
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: params.type === '2' ? 'json' : 'arraybuffer',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
